import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import encode from '~/utils/encode';

import './form.scss';

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      privacyPolicy: '',
      sent: false,
      error: '',
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const {
      name,
      email,
      message,
      privacyPolicy,
    } = this.state;

    if (!name || !email || !message) {
      this.setState({ error: 'Please, fill all the fields!' });
      return;
    }

    if (!privacyPolicy) {
      this.setState({ error: 'Please, read and accept the Privacy Policy!' });
      return;
    }

    let body = {
      'form-name': form.getAttribute('name'),
      name,
      email,
      message,
      privacyPolicy,
    };

    if (this.props.metadata) {
      body = { ...body, ...this.props.metadata };
    }

    body = encode(body);

    try {
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });

      this.setState({ sent: true });
    } catch (error) {
      this.setState({ error: 'Something went wrong! Try again later...' });
      console.error(error);
    }
  };

  render() {
    const { handleSubmit, handleChange } = this;
    const { error, sent } = this.state;
    const { name, metadata } = this.props;

    return pug`
      .form__container(className=(sent ? "form__container--succeeded" : ""))
        .form__result
          p A push notification just buzzed on my phone...
            br
            | I'm reading your message right now and I'll reply you ASAP!
        form.form(
          name=name,
          method="post",
          data-netlify="true",
          data-netlify-honeypot="bot-field",
          onSubmit=handleSubmit
        )
          input(type="hidden", name="form-name", value=name)
          p(hidden)
            label Don’t fill this out
              input(name="bot-field", placeholder="Text for robots", onChange=handleChange)
          .input-group
            label(for="name") Your name
            input#name(name="name", type="text", placeholder="Emanuele Bianchi", required, onChange=handleChange)
          .input-group
            label(for="email") Your email
            input#email(name="email", type="email", placeholder="your@email.com", required, onChange=handleChange)
          .input-group
            label(for="message") Message
            textarea#message(name="message", placeholder="How can I help you?", rows="4", required, onChange=handleChange)
          if metadata
            each key in Object.keys(metadata)
              input(type="hidden", key=key, name=key, value=metadata[key])
          if error
            .input-group__error-message
              p=error
          .input-group.input-group--submit
            button(type="submit") Send
            .input-group--checkbox
              input#privacyPolicy(name="privacyPolicy", type="checkbox", required, onChange=handleChange)
              label(for="privacyPolicy") I have read and agree to the&nbsp;
                Link(to="/privacy-policy") Privacy Policy
    `;
  }
}

Form.propTypes = {
  name: PropTypes.string.isRequired,
  metadata: PropTypes.object,
};

export default Form;
